module.exports = __webpack_public_path__ + "static/media/plus.a079338d.svg";